<header class="header flex align-items-center" *ngIf="!isSSOFlow">
  <div class="flex-1">
    <a href="/">
      <img
        class="visa-logo"
        src="https://images.poshvine.com/visa-gcc/visa-logo.svg"
        alt="visa logo" />
    </a>
  </div>

  <ng-template #logoutBtn>
    <button
      name="logout-button"
      *ngIf="isUserLoggedIn"
      class="flex justify-content-center align-items-center bg-none border-none cursor-pointer font-medium pv-text-14px gap-2"
      (click)="logout()"
      data-testid="logout-button">
      <img
        src="https://images.poshvine.com/axis-airtel/log-out-black.svg"
        alt="logout-icon"
        class="h-24px"
        [ngStyle]="isMobile ? mobileIconStyle : {}" />
      {{ env.staticTextContents.headerComponent.logoutButtonLabel }}
    </button>
  </ng-template>

  <ng-template #orderHistoryBtn>
    <button
      name="order-history-button"
      type="button"
      *ngIf="
        isUserLoggedIn && (env.orderHistoryFlag || env.tierGamificationFlag)
      "
      class="flex align-items-center gap-2 pv-text-14px font-medium text-black border-none bg-none mr-4 cursor-pointer text-left"
      (click)="navigateToHistory()">
      <img
        class="h-24px"
        src="https://images.poshvine.com/icon/history-icon-black.svg"
        [ngStyle]="isMobile ? mobileIconStyle : {}"
        alt="history-icon" />
      {{ env.staticTextContents.commonTexts.orderHistory }}
    </button>
  </ng-template>

  <ng-template #searchBtn>
    <button
      name="search-button"
      *ngIf="env.offerSearchFlag && isUserLoggedIn && showSearchIcon"
      type="button"
      (click)="openSearchModal()"
      class="bg-none border-none my-auto mr-3 cursor-pointer flex align-items-center gap-2 pv-text-14px font-medium text-black">
      <img
        class="h-20px"
        src="https://images.poshvine.com/icon/search-icon-black.svg"
        [ngStyle]="isMobile ? mobileIconStyle : {}"
        alt="search-icon" />
      <span class="flex md:hidden">
        {{ env.staticTextContents.headerComponent.search }}
      </span>
    </button>
  </ng-template>

  <ng-template #languageSelector>
    <div
      #dropdownRef
      class="language-selector mr-3 relative"
      *ngIf="env.showLanguageDropdown">
      <div
        class="language-trigger cursor-pointer flex align-items-center gap-1"
        tabindex="0"
        role="button"
        (click)="languageDropdownClicked = !languageDropdownClicked"
        (keydown.enter)="languageDropdownClicked = !languageDropdownClicked"
        (keydown.space)="languageDropdownClicked = !languageDropdownClicked">
        <img
          src="https://assets.poshvine.com/merchants/visa/common/icons/language-icon.svg"
          alt="Language"
          class="language-icon" />
        <p class="m-0 text-black pv-text-14px hidden md:inline-block">
          {{ selectedLanguageLabel }}
        </p>
        <i class="pi pi-chevron-down text-black"></i>
      </div>
      <div
        *ngIf="languageDropdownClicked"
        class="language-dropdown border-round-lg overflow-hidden custom-box-shadow absolute z-1 mt-3 bg-white">
        <div
          *ngFor="let lang of languages"
          class="language-option cursor-pointer pv-px-24px pv-py-8px"
          role="button"
          tabindex="0"
          (click)="onLanguageChange(lang.code)"
          (keydown.enter)="onLanguageChange(lang.code)"
          (keydown.space)="onLanguageChange(lang.code)">
          {{ lang.label }}
        </div>
      </div>
    </div>
  </ng-template>

  <a
    [href]="'mailto:' + env.footerComponent.emailId"
    tabindex="0"
    pTooltip="Please click here to contact us through mail"
    tooltipPosition="top"
    class="cursor-pointer font-bold mr-3 flex align-items-center justify-content-center"
    [tooltipEvent]="isMobile ? 'focus' : 'hover'">
    <img
      [src]="env.headerComponent.customerSupportIconUrl"
      alt="customer-support-icon"
      class="h-24px" />
  </a>

  <ng-container *ngTemplateOutlet="languageSelector"></ng-container>

  <div class="hidden md:flex align-items-center" *ngIf="isUserLoggedIn">
    <ng-container *ngTemplateOutlet="searchBtn"></ng-container>
    <ng-container *ngTemplateOutlet="orderHistoryBtn"></ng-container>
    <ng-container *ngTemplateOutlet="logoutBtn"></ng-container>
  </div>

  <button
    name="login-button"
    *ngIf="!isUserLoggedIn"
    class="bg-primary border-none border-round-sm py-3 px-4 font-semibold text-white pv-text-14px cursor-pointer"
    type="button"
    (click)="showLoginModal('login')"
    data-testid="login-button">
    {{ env.staticTextContents.commonTexts.loginButtonLabel }}
  </button>

  <p-sidebar
    *ngIf="isUserLoggedIn"
    [(visible)]="sidebarVisible"
    position="right"
    [showCloseIcon]="false">
    <div class="flex flex-column gap-5 align-items-start">
      <button
        class="flex align-items-center gap-2 bg-none border-none"
        (click)="sidebarVisible = false">
        <img
          src="https://images.poshvine.com/visa-gcc/arrow-left-icon.svg"
          alt="back-icon"
          class="h-10px" />
        <p class="m-0 pv-text-10px font-semibold text-black">Back</p>
      </button>
      <ng-container *ngTemplateOutlet="searchBtn"></ng-container>
      <ng-container *ngTemplateOutlet="orderHistoryBtn"></ng-container>
      <ng-container *ngTemplateOutlet="logoutBtn"></ng-container>
    </div>
  </p-sidebar>

  <button
    *ngIf="isUserLoggedIn"
    aria-label="Open menu"
    (click)="sidebarVisible = true"
    class="block md:hidden bg-none border-none">
    <img
      src="https://assets.poshvine.com/merchants/visa/ssa/icons/menu-icon-gray.svg"
      alt="hamburger-menu-icon" />
  </button>
</header>
<visa-platform-signup />
<visa-platform-search-bar />
